"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDTOraw = exports.toDomainRaw = exports.GenericMap = exports.isObjectWithValueProp = void 0;
const tslib_1 = require("tslib");
const is_primitive_1 = tslib_1.__importDefault(require("is-primitive"));
const lodash_1 = require("lodash");
const fast_safe_stringify_1 = tslib_1.__importDefault(require("fast-safe-stringify"));
const AggregateRoot_1 = require("../../core/domain/AggregateRoot");
const Entity_1 = require("../../core/domain/Entity");
const EnumObject_1 = require("../../core/domain/EnumObject");
const SyncedObject_1 = require("../../core/domain/SyncedObject");
const ValueObject_1 = require("../../core/domain/ValueObject");
const utils_1 = require("../../core/infra/utils");
exports.isObjectWithValueProp = (v) => {
    return v && (Entity_1.isEntity(v) || AggregateRoot_1.isAggregateRoot(v) || ValueObject_1.isValueObject(v) || SyncedObject_1.isSyncedObject(v)) && !!v.value;
};
class GenericMap {
    static toDTO(domainObject) {
        if (!domainObject) {
            throw new Error("Domain object empty");
        }
        return GenericMap.mapDomainValue(domainObject);
    }
    static mapDomainProperties(domainObject) {
        const result = {};
        for (const entry of Object.entries(domainObject)) {
            const key = entry[0];
            const value = entry[1];
            const mappedValue = GenericMap.mapDomainValue(value, key);
            if (utils_1.isUndefined(mappedValue))
                continue;
            if (value != null)
                result[key] = mappedValue;
        }
        return result;
    }
    /*
  
    private static validate(dClass, dto): void {
      if (isFunction(dClass.domainClass.validate)) {
        const vr = dClass.domainClass.validate(dto);
        if (!vr.pass) {
          throw new Error(`Generic mapper error. Schema validation error:${vr.msg}`);
        }
      } else {
        console.log(
          `Schema validation for class ${dClass.name} not implemented. Add validate(p:any):IGuardRes method to class`
        );
        console.log("Letting continue");
      }
    }
  */
    static mapDomainValue(anything, key) {
        if (!anything || lodash_1.isBoolean(anything) || is_primitive_1.default(anything))
            return anything;
        /*
    
        if (isBoolean(value)) {
          return value;
        }
    
        if (isPrimitive(value)) {
          if (isString(value)) return value || null;
          return value;
        }
    */
        if (GenericMap.isPrimitiveDomainObject(anything)) {
            return anything.value;
        }
        if (EnumObject_1.isEnumObject(anything)) {
            return anything.value;
        }
        if (exports.isObjectWithValueProp(anything)) {
            return GenericMap.mapDomainProperties(anything.value);
        }
        //array
        if (Array.isArray(anything) && anything.length > 0) {
            return anything.map((item) => GenericMap.mapDomainValue(item));
        }
        //indexed object
        if (lodash_1.isObject(anything) && Object.keys(anything).length > 0) {
            const res = {};
            for (const e of Object.entries(anything)) {
                res[e[0]] = GenericMap.mapDomainValue(e[1]);
            }
            return res;
        }
        //Array
        //indexed object
        console.log(`Value:${key} ${fast_safe_stringify_1.default(anything)} not mapped. Returning undefined`);
        return undefined;
    }
    static isPrimitiveDomainObject(value) {
        return lodash_1.isFunction(value.isPrimitive) && value.isPrimitive();
    }
}
exports.GenericMap = GenericMap;
function toDomainRaw(raw) {
    return raw;
}
exports.toDomainRaw = toDomainRaw;
function toDTOraw(d) {
    return d;
}
exports.toDTOraw = toDTOraw;
//# sourceMappingURL=GenericMap.js.map